import { useLayoutEffect, useRef } from 'react';

import { TaxonomyType } from '@revelio/data-access';

import { useActivityTaxonomyConfig } from '../../../shared/selection-lists/hooks/useActivityTaxonomyConfig';
import { useCurrentReferenceTaxonomyVersion } from '../../../shared/selection-lists/hooks/useReferenceTaxonomyVersions';
import { useCurrentRoleTaxonomyVersion } from '../../../shared/selection-lists/hooks/useRoleTaxonomyAdapter';
import { useTabContentConfig } from '../components/PageConfigProvider/PageConfigProvider';
import { useFilterContext } from '../filters/contexts/FilterProvider';
import { getOrCreateFilters } from '../filters/engine/filterGroupConsistency';
import { getConsistencyKey } from '../filters/utils/consistencyKey';

export const useSyncActiveFilterGroup = () => {
  const { filterState, dispatch: filterDispatch } = useFilterContext();
  const { config, revelioPageId } = useTabContentConfig();

  const { version: roleTaxonomyVersion } = useCurrentRoleTaxonomyVersion();
  const { version: skillTaxonomyVersion } = useCurrentReferenceTaxonomyVersion({
    taxonomyType: TaxonomyType.Skill,
  });
  const activityTaxonomyConfig = useActivityTaxonomyConfig();

  const consistencyKey = getConsistencyKey({
    revelioPageId,
    primaryFilterId: config.primaryFilter?.id,
  });

  const filterStateRef = useRef(filterState);
  filterStateRef.current = filterState;
  const taxonomyConfig = {
    roleTaxonomyVersion,
    skillTaxonomyVersion,
    ...activityTaxonomyConfig,
  };
  const taxonomyConfigRef = useRef(taxonomyConfig);
  taxonomyConfigRef.current = taxonomyConfig;

  // Use layout effect so the active filter group switches before the user can
  // interact with UI (prevents applying preferences/updates to the wrong group).
  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional dependency list
  useLayoutEffect(() => {
    filterDispatch({
      type: 'REPLACE_FILTERS',
      payload: {
        filterMap: getOrCreateFilters(
          filterStateRef.current,
          consistencyKey,
          taxonomyConfigRef.current
        ),
        consistencyKey,
      },
    });
  }, [consistencyKey]);
};
